import { useFeatureFlag as useConfigcatFeatureFlag } from 'configcat-react';
import { useMemo } from 'react';
import { useUserObject } from './useUserObject';

export function useFeatureFlag(key: string, defaultValue: any) {
	const { roles, userEmail, loading: userobjectLoading } = useUserObject();

	const userObject = useMemo(() => {
		if (!userEmail && !roles) return;

		return {
			identifier: userEmail || '',
			custom: {
				'user-roles': `/${roles?.join('/')}/`
			}
		};
	}, [roles, userEmail]);

	const { value, loading: configcatLoading } = useConfigcatFeatureFlag(
		key,
		defaultValue,
		userObject
	);

	return { value, loading: userobjectLoading || configcatLoading };
}
